import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import FileIcon from 'components/FileIcon/FileIcon';
import LazyFlag from 'components/LazyFlag/LazyFlag';
import styled from 'styled-components';

export const CentralButtonContainer = styled.div`
    text-align: center;
    flex: 1;
`;

export const FlexContainer = styled.div`
    display: flex;
`;

export const LeftButtonContainer = styled.div`
    text-align: left;
    flex: 1;
`;

export const RightButtonContainer = styled.div`
    text-align: right;
    flex: 1;
`;

export const StyledCard = styled(Card)`
    margin: 8px;
    min-width: 300px;
    min-height: 200px;
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const StyledCardContent = styled(CardContent)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const StyledChip = styled(Chip)`
    overflow: hidden;
    margin-left: 8px;
    margin-bottom: 6px;
    flex-shrink: 0;
`;

export const StyledIconButton = styled(IconButton)`
    margin: 0 4px;
`;

export const StyledTypography = styled(Typography)`
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StyledFileIcon = styled(FileIcon)`
    max-height: 80px;
    margin-bottom: 12px;
`;

export const UserNameTypography = styled(Typography)`
    margin-top: 10px;
`;

export const StyledFlag = styled(LazyFlag)`
    max-width: 32px;
`;